module.exports = __webpack_public_path__ + "static/img/detail_addperson.c684f80d.svg";